import Animate from "./partials/animate";
import Header from "./partials/header";
import ExpertListing from "./partials/expert-listing";
import Form from "./partials/form";
import SiteVisitForm from "./partials/site-visit-form";
import TrumpSlider from "./partials/trump-slider";
import RefSlider from "./partials/ref-slider";
import GalleryLightboxes from "./partials/gallery-lightbox";
import Map from "./partials/map";
import ListFilter from "./partials/list-filter";
import Accordeon from "./partials/accordeon";
import CookieNotice from "./partials/cookie-notice";
import DatePicker from "./partials/date-picker";
import FieldsetRepeatable from "./partials/fieldset-repeatable";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($element => (new Animate($element)));
    $wrapper.querySelectorAll('[data-header]').forEach($element => (new Header($element)));
    $wrapper.querySelectorAll('[data-expert-list]').forEach($element => (new ExpertListing($element)));
    $wrapper.querySelectorAll('[data-form]').forEach($element => (new Form($element)));
    $wrapper.querySelectorAll('[data-site-visit-form]').forEach($element => (new SiteVisitForm($element)));
    $wrapper.querySelectorAll('[data-trump-slider]').forEach($element => (new TrumpSlider($element)));
    $wrapper.querySelectorAll('[data-ref-slider]').forEach($element => (new RefSlider($element)));
    $wrapper.querySelectorAll('[data-gallery-lightboxes]').forEach($element => (new GalleryLightboxes($element)));
    $wrapper.querySelectorAll('[data-map]').forEach($element => (new Map($element)));
    $wrapper.querySelectorAll('[data-list-filter]').forEach($element => (new ListFilter($element)));
    $wrapper.querySelectorAll('[data-accordeon]').forEach($element => (new Accordeon($element)));
    $wrapper.querySelectorAll('[data-date-picker]').forEach($element => (new DatePicker($element)));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));

    (new CookieNotice())
}

(function() {
    window.initDom(document);
})();
